import { Box, styled } from '@mui/material';

const NewsFeedSliderContainer = styled(Box)(({ theme }) => ({
  '.slick-dots': {
    backgroundColor: '#fff',
    borderBottomLeftRadius: '6px',
    borderBottomRightRadius: '6px',
    bottom: '0px'
  },
  '.slick-dots li:not(.slick-active) button::before': {
    color: theme.palette.mode === 'light' ? '#555' : theme.palette.customColors.primaryGradient,
    opacity: 1
  },
  '.slick-dots li.slick-active button::before': {
    color: theme.palette.mode === 'light' ? '#32cd32' : theme.palette.secondary,
    opacity: '1'
  },
  '.slick-slider': { height: '100%' },
  '.slick-list': { height: '100%' },
  '.slick-track': { display: 'flex', width: '100% !important', height: '100%' },
  '.slick-slide': { marginLeft: '20px', width: '100%', flex: '1 0 100%' },
  '.slick-slide > div:first-of-type': { height: '100%' },
  '.slick-list [data-slick-index="0"]': { marginLeft: 0 },
  width: '100%',
  margin: '0px auto 10px',
  display: 'block',
  height: '100%',
  position: 'relative'
}));

export default NewsFeedSliderContainer;
